import { APP_PREFIX_PATH } from 'configs/AppConfig'
import * as routeKeys from 'constants/RoutesKeys'

export const PAGES_PREFIX = `${APP_PREFIX_PATH}/pages`
export const ADMINS_PREFIX = `${APP_PREFIX_PATH}/admins`

/** URL segments keyed by permission key (RoutesKeys). */
export const PAGE_ROUTE_SEGMENTS = {
  [routeKeys.templateKey]: {
    slug: 'template',
    list: 'template-list',
    add: 'add-template',
    edit: 'edit-template',
  },
  [routeKeys.widgetsKey]: {
    slug: 'widgets',
    list: 'widgets-list',
    add: 'add-widget',
    edit: 'edit-widget',
  },
  [routeKeys.bannerKey]: {
    slug: 'banners',
    list: 'banner-list',
    add: 'add-banner',
    edit: 'edit-banner',
  },
  [routeKeys.contactUsKey]: {
    slug: 'contact-us',
    list: 'contact-list',
    statusHistory: 'status-history',
  },
  [routeKeys.seoKey]: {
    slug: 'seo',
    list: 'seo-list',
    add: 'add-seo',
    edit: 'edit-seo',
  },
  [routeKeys.notificationKey]: {
    slug: 'notification',
    list: 'notification-list',
    statusHistory: 'status-history',
  },
  [routeKeys.categoriesKey]: {
    slug: 'categories',
    list: 'categories-list',
    add: 'add-category',
    edit: 'edit-category',
  },
  [routeKeys.pagesKey]: {
    slug: 'pages',
    list: 'pages-list',
    add: 'add-page',
    edit: 'edit-page',
  },
  [routeKeys.informationPolicyKey]: {
    slug: 'information-policy',
    list: 'information-policy-list',
    add: 'add-information-policy',
    edit: 'edit-information-policy',
  },
  [routeKeys.adminSettingsKey]: {
    slug: 'admin-settings',
    list: 'edit-admin-settings',
    add: 'add-admin-settings',
    edit: 'edit-admin-settings',
  },
  [routeKeys.configSettingsKey]: {
    slug: 'config-settings',
    list: 'edit-config-settings',
    add: 'add-config-settings',
    edit: 'edit-config-settings',
  },
  [routeKeys.galleryKey]: {
    slug: 'gallery',
    list: 'gallery-list',
    add: 'add-gallery',
    edit: 'edit-gallery',
  },
  [routeKeys.officialContactKey]: {
    slug: 'official-contact',
    list: 'official-contact-list',
    add: 'add-official-contact',
    edit: 'edit-official-contact',
  },
  [routeKeys.administrationKey]: {
    slug: 'administration',
    list: 'administration-list',
    add: 'add-administration',
    edit: 'edit-administration',
    previous: 'previous-administrators',
  },
  [routeKeys.parishPriestKey]: {
    slug: 'parish-priest',
    list: 'parish-priest-list',
    add: 'add-parish-priest',
    edit: 'edit-parish-priest',
  },
  [routeKeys.previousAdministratorsKey]: {
    slug: 'administration',
    list: 'previous-administrators',
  },
  [routeKeys.leadershipHistoryKey]: {
    slug: 'leadership-history',
    list: 'leadership-history-list',
    add: 'add-leadership-history',
    edit: 'edit-leadership-history',
  },
  [routeKeys.houseKey]: {
    slug: 'house',
    list: 'house-list',
    add: 'add-house',
    edit: 'edit-house',
    members: 'house-members-list',
  },
  [routeKeys.historyKey]: {
    slug: 'history',
    list: 'history-list',
    add: 'add-history',
    edit: 'edit-history',
  },
  [routeKeys.hierarchyKey]: {
    slug: 'hierarchy',
    list: 'hierarchy-list',
    add: 'add-hierarchy',
    edit: 'edit-hierarchy',
  },
  [routeKeys.positionKey]: {
    slug: 'position',
    list: 'position-list',
    add: 'add-position',
    edit: 'edit-position',
  },
  [routeKeys.churchKey]: {
    slug: 'church',
    list: 'church-list',
    add: 'add-church',
    edit: 'edit-church',
  },
  [routeKeys.organizationKey]: {
    slug: 'organization',
    list: 'organization-list',
    add: 'add-organization',
    edit: 'edit-organization',
  },
  [routeKeys.membersKey]: {
    slug: 'members',
    list: 'members-list',
    add: 'add-member',
    edit: 'edit-member',
  },
  [routeKeys.chapelKey]: {
    slug: 'chapel',
    list: 'chapel-list',
    add: 'add-chapel',
    edit: 'edit-chapel',
  },
  [routeKeys.newsKey]: {
    slug: 'news',
    list: 'news-list',
    add: 'add-news',
    edit: 'edit-news',
  },
  [routeKeys.festivalsKey]: {
    slug: 'festivals',
    list: 'festivals-list',
    add: 'add-festival',
    edit: 'edit-festival',
  },
  [routeKeys.advertisementKey]: {
    slug: 'advertisement',
    list: 'advertisement-list',
    add: 'add-advertisement',
    edit: 'edit-advertisement',
  },
  [routeKeys.occasionKey]: {
    slug: 'occasion',
    list: 'occasion-list',
    add: 'add-occasion',
    edit: 'edit-occasion',
  },
  [routeKeys.liveStreamingKey]: {
    slug: 'live-streaming',
    list: 'live-streaming-list',
    add: 'add-live-streaming',
    edit: 'edit-live-streaming',
  },
  [routeKeys.incomePdfLinkKey]: {
    slug: 'income-pdf-link',
    list: 'income-pdf-link-list',
    add: 'add-income-pdf-link',
    edit: 'edit-income-pdf-link',
  },
  [routeKeys.eventsKey]: {
    slug: 'events',
    list: 'events-list',
    add: 'add-event',
    edit: 'edit-event',
  },
  [routeKeys.quotesKey]: {
    slug: 'quotes',
    list: 'quotes-list',
    add: 'add-quote',
    edit: 'edit-quote',
  },
}

export const ADMIN_ROUTE_SEGMENTS = {
  [routeKeys.subadminsKey]: {
    slug: 'subadmins',
    list: 'subadmins-list',
    add: 'add-subAdmin',
    edit: 'edit-subAdmin',
  },
  [routeKeys.subadminRolesKey]: {
    slug: 'subadmin-roles',
    list: 'subadmin-roles-list',
    add: 'add-subadmin-role',
    edit: 'edit-subadmin-role',
  },
}

export const getPageSegment = (permissionKey, segment) =>
  PAGE_ROUTE_SEGMENTS[permissionKey]?.[segment]

export const getPageBasePath = (permissionKey) => {
  const slug = getPageSegment(permissionKey, 'slug')
  return slug ? `${PAGES_PREFIX}/${slug}` : PAGES_PREFIX
}

export const getPageWildcardPath = (permissionKey) =>
  `${getPageBasePath(permissionKey)}/*`

export const getPageListPath = (permissionKey) => {
  const list = getPageSegment(permissionKey, 'list')
  return list ? `${getPageBasePath(permissionKey)}/${list}` : getPageBasePath(permissionKey)
}

export const getPageAddPath = (permissionKey) =>
  `${getPageBasePath(permissionKey)}/${getPageSegment(permissionKey, 'add')}`

export const getPageEditBasePath = (permissionKey) =>
  `${getPageBasePath(permissionKey)}/${getPageSegment(permissionKey, 'edit')}`

export const getPageEditPath = (permissionKey, id) =>
  `${getPageEditBasePath(permissionKey)}/${id}`

/** Relative route segment for nested `<Route path=... />`. */
export const getPageListRoute = (permissionKey) =>
  getPageSegment(permissionKey, 'list')

export const getPageAddRoute = (permissionKey) =>
  getPageSegment(permissionKey, 'add')

export const getPageEditRoute = (permissionKey) =>
  `${getPageSegment(permissionKey, 'edit')}/:id`

export const getPageListNavigateTo = (permissionKey, pageSize) =>
  `${getPageListRoute(permissionKey)}?page=1&limit=${pageSize}`

export const getPageListPathWithPagination = (permissionKey, pageSize) =>
  `${getPageListPath(permissionKey)}?page=1&limit=${pageSize}`

export const getPageStatusHistoryPath = (permissionKey, id) => {
  const list = getPageSegment(permissionKey, 'list')
  const statusHistory = getPageSegment(permissionKey, 'statusHistory')
  return `${getPageBasePath(permissionKey)}/${list}/${statusHistory}/${id}`
}

export const getPageStatusHistoryRoute = (permissionKey) => {
  const list = getPageSegment(permissionKey, 'list')
  const statusHistory = getPageSegment(permissionKey, 'statusHistory')
  return `${list}/${statusHistory}/:notificationId`
}

export const getPagePreviousPath = (permissionKey) =>
  `${getPageBasePath(permissionKey)}/${getPageSegment(permissionKey, 'previous')}`

export const getPagePreviousRoute = (permissionKey) =>
  getPageSegment(permissionKey, 'previous')

export const getPageMembersPath = (permissionKey) =>
  `${getPageBasePath(permissionKey)}/${getPageSegment(permissionKey, 'members')}`

export const getPageMembersRoute = (permissionKey) =>
  getPageSegment(permissionKey, 'members')

export const getPageMembersNavigateTo = (permissionKey, pageSize) =>
  `${getPageMembersPath(permissionKey)}?page=1&limit=${pageSize}`

export const getAdminSegment = (permissionKey, segment) =>
  ADMIN_ROUTE_SEGMENTS[permissionKey]?.[segment]

export const getAdminBasePath = (permissionKey) => {
  const slug = getAdminSegment(permissionKey, 'slug')
  return slug ? `${ADMINS_PREFIX}/${slug}` : ADMINS_PREFIX
}

export const getAdminWildcardPath = (permissionKey) =>
  `${getAdminBasePath(permissionKey)}/*`

export const getAdminListPath = (permissionKey) =>
  `${getAdminBasePath(permissionKey)}/${getAdminSegment(permissionKey, 'list')}`

export const getAdminAddPath = (permissionKey) =>
  `${getAdminBasePath(permissionKey)}/${getAdminSegment(permissionKey, 'add')}`

export const getAdminEditBasePath = (permissionKey) =>
  `${getAdminBasePath(permissionKey)}/${getAdminSegment(permissionKey, 'edit')}`

export const getAdminEditPath = (permissionKey, id) =>
  `${getAdminEditBasePath(permissionKey)}/${id}`

export const getAdminListRoute = (permissionKey) =>
  getAdminSegment(permissionKey, 'list')

export const getAdminAddRoute = (permissionKey) =>
  getAdminSegment(permissionKey, 'add')

export const getAdminEditRoute = (permissionKey) =>
  `${getAdminSegment(permissionKey, 'edit')}/:id`

export const getAdminListNavigateTo = (permissionKey, pageSize) =>
  `${getAdminListRoute(permissionKey)}?page=1&limit=${pageSize}`
